import { useStyles } from '@webapps/styles';

export default function Nodata({ image, title, description, padding = "20px", contentWidth = '40%', borderRadius = "12px", backgroundColor, width }) {
  const { classes, cx } = useStyles(styles);

  const containerStyle = { padding };
  containerStyle.borderRadius = borderRadius;

  if (backgroundColor) {
    containerStyle.backgroundImage = 'none';
    containerStyle.backgroundColor = backgroundColor;
  }

  return (
    <div className={cx(classes["framerDiv"])} style={containerStyle}>
      {image &&
        <img
          className={classes["framerImg"]}
          src={image}
          alt={title || "Image"}
          style={{ width: width ? width : image.sizes }}
        />
      }
      <div className={classes["framerDiv2"]} style={{ width: contentWidth }}>
        <div className={classes["framerP"]}>{title}</div>
        <div className={classes["framerP2"]}>{description}</div>
      </div>
    </div>
  );
}

const styles = ({ spacing }) => ({
  "framerDiv": {
    backgroundImage: "linear-gradient(rgba(242, 247, 255, 0.2) 50%, #f3f7ff 100%)",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
    height: "100%",
    gap: "20px",
    overflow: "hidden",
    placeItems: "center",
    justifyContent: "center",
  },
  "framerImg": {
    width: "15%",
  },
  "framerDiv2": {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "10px",
    overflow: "hidden",
  },
  "framerP": {
    fontFamily: "\"Montserrat\", sans-serif",
    fontSize: "14px",
    fontWeight: "600",
    color: "#152652",
    textAlign: "center",
  },
  "framerP2": {
    fontFamily: "\"Roboto\", sans-serif",
    fontSize: "12px",
    color: "#5d75a8",
    textAlign: "center",

  },
});